import React from "react";
import { sanitizeNonNegativeInput } from "../../utils/nonNegativeInput";

const parseOptionalNumber = (value) => {
  if (value === "" || value == null) return null;
  const parsed = Number(String(value).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
};

const buildBuyInLabel = (preferences) => {
  const min = preferences?.buyInMin || "";
  const max = preferences?.buyInMax || "";

  if (min && max) return `Buy-in ${min} - ${max}`;
  if (min) return `Buy-in min ${min}`;
  if (max) return `Buy-in max ${max}`;
  return "Buy-in";
};

export default function BuyInPreferencePopover({
  preferences = {},
  onChange = () => {},
}) {
  const [open, setOpen] = React.useState(false);
  const [draftRange, setDraftRange] = React.useState({
    buyInMin: preferences.buyInMin || "",
    buyInMax: preferences.buyInMax || "",
  });
  const popoverRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    setDraftRange({
      buyInMin: preferences.buyInMin || "",
      buyInMax: preferences.buyInMax || "",
    });
  }, [open, preferences.buyInMax, preferences.buyInMin]);

  React.useEffect(() => {
    if (!open) return undefined;

    const handleDocumentMouseDown = (event) => {
      if (!popoverRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentMouseDown);
    return () => document.removeEventListener("mousedown", handleDocumentMouseDown);
  }, [open]);

  const handleRangeChange = (field, value) => {
    setDraftRange({
      ...draftRange,
      [field]: sanitizeNonNegativeInput(value, 9),
    });
  };

  const clearRange = () => {
    const nextPreferences = {
      ...preferences,
      buyInMin: "",
      buyInMax: "",
    };
    setDraftRange({ buyInMin: "", buyInMax: "" });
    onChange(nextPreferences);
  };

  const applyRange = () => {
    const buyInMin = draftRange.buyInMin || "";
    let buyInMax = draftRange.buyInMax || "";
    const minNumber = parseOptionalNumber(buyInMin);
    const maxNumber = parseOptionalNumber(buyInMax);

    if (minNumber != null && maxNumber != null && maxNumber < minNumber) {
      buyInMax = buyInMin;
    }

    const nextPreferences = {
      ...preferences,
      buyInMin,
      buyInMax,
    };

    setDraftRange({
      buyInMin: nextPreferences.buyInMin,
      buyInMax: nextPreferences.buyInMax,
    });
    onChange(nextPreferences);
    setOpen(false);
  };

  return (
    <div className="buy-in-preference" ref={popoverRef}>
      <button
        className="btn-ghost buy-in-preference__trigger"
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        {buildBuyInLabel(preferences)}
      </button>

      {open && (
        <div className="buy-in-preference__popover">
          <div>
            <label className="field-label">Min</label>
            <input
              className="input-field"
              type="number"
              min="0"
              placeholder="0"
              value={draftRange.buyInMin}
              onChange={(event) =>
                handleRangeChange("buyInMin", event.target.value)
              }
            />
          </div>

          <div>
            <label className="field-label">Max</label>
            <input
              className="input-field"
              type="number"
              min="0"
              placeholder="Sem limite"
              value={draftRange.buyInMax}
              onChange={(event) =>
                handleRangeChange("buyInMax", event.target.value)
              }
            />
          </div>

          <div className="buy-in-preference__actions">
            <button
              className="btn-ghost buy-in-preference__clear"
              type="button"
              onClick={clearRange}
            >
              Limpar
            </button>
            <button
              className="btn-red btn-confirm-action buy-in-preference__ok"
              type="button"
              onClick={applyRange}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
